import { render, staticRenderFns } from "./debt_amount_summary.vue?vue&type=template&id=c8c3b170&"
import script from "./debt_amount_summary.vue?vue&type=script&lang=js&"
export * from "./debt_amount_summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports